<template>
	<div>
		<van-cell-group>
			<van-cell class="list-item" v-for="(it, index) in classList" :key=index :title=it.name is-link @click='navTo(it)' />
		</van-cell-group>
		<bottom-tab></bottom-tab>
	</div>
</template>

<script>
	import Vue from 'vue';
	import api from '../../http/api.js'
	import {
		Cell,
		CellGroup,
		Toast
	} from 'vant';
	Vue.use(Cell);
	Vue.use(CellGroup);
	Vue.use(Toast);

	export default {
		data() {
			return {
				classList: [],
				uid: window.localStorage.getItem('uid'),
				type: 0,
                isClassTemp: false
			}
		},
		methods: {
			pageInit() {
				if (this.$route.query.type) {
					this.type = 1
				}
				if(this.$route.query.isClassTemp){
				    this.isClassTemp = true
                }
				api.getClassList(this.uid).then(res => {
					if (res.data.code == 200) {
						for (let i = 0; i < res.data.data.length; i++) {
							this.classList.push(res.data.data[i])
						}
					} else {
						Toast('获取失败：' + res.data.msg)
					}
				})

			},
			navTo(it) {
                this.$router.push({
                    path: '/classDaily',
                    query: {
                        id: it.id,
                        isClassTemp: this.isClassTemp
                    }
                })
				// if (this.type == 1) {
				// 	this.$router.push({
				// 		path: '/classDaily',
				// 		query: {
				// 			id: it.id
				// 		}
				// 	})
				// } else {
				// 	this.$router.push({
				// 		path: '/classTemp',
				// 		query: {
				// 			id: it.id
				// 		}
				// 	})
				// }
			}
		},
		mounted() {
			this.pageInit()
		}
	}
</script>

<style>
</style>
